import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import type { FC } from "react";
import { useAuthUser } from "../../hooks/authentication";
import { useDigitalSampleRequests } from "../../hooks/digital-sample-requests";

export interface RequestedDigitalSamplesProps {
  material: ColoredMaterial;
}

export const RequestedDigitalSamples: FC<RequestedDigitalSamplesProps> = ({
  material,
}) => {
  const [digitalSampleRequests] = useDigitalSampleRequests(
    material.eljExperimentId,
    true,
  );
  const { user } = useAuthUser();
  if (!digitalSampleRequests?.length) {
    return null;
  }
  return (
    <>
      <p>The following finishes have already been requested</p>
      <ul>
        {digitalSampleRequests?.map((r) => (
          <li key={r.id}>
            <b>{r.materialFinish}</b>:{" "}
            {user?.email === r.requester ? "you " : "someone else "}
            requested this on {new Date(r.creationDate).toLocaleDateString()}
          </li>
        ))}
      </ul>
    </>
  );
};
